var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8476 15.0592L47.6119 24.8234L22.8958 49.5395L13.137 39.7753L37.8476 15.0592ZM55.0211 12.7043L50.6666 8.34979C48.9837 6.66693 46.2511 6.66693 44.5625 8.34979L40.3913 12.521L50.1556 22.2852L55.0211 17.4198C56.3263 16.1145 56.3263 14.0095 55.0211 12.7043ZM8.02717 53.4997C7.84947 54.2994 8.57152 55.016 9.37134 54.8215L20.252 52.1833L10.4932 42.4192L8.02717 53.4997Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4114072a889c0b199a718795c920d244.svg";
export { ForwardRef as ReactComponent };